import { useTranslation } from 'react-i18next';
import type { IAdminTag } from '@interfaces/IAdminTag';
import { Modal } from '@components/ui/Modal/Modal';
import { Button } from '@components/ui/Button/Button';
import styles from './UnassignTagDialog.module.css';

interface IUnassignTagDialogProps {
  tag: IAdminTag;
  unassigning: boolean;
  onConfirm: (tag: IAdminTag) => void;
  onClose: () => void;
}

export function UnassignTagDialog({ tag, unassigning, onConfirm, onClose }: IUnassignTagDialogProps) {
  const { t } = useTranslation();
  return (
    <Modal
      open
      onClose={onClose}
      title={t('adminTags.unassignFlow.title')}
      footer={
        <>
          <span className={styles.footerSpacer} />
          <Button variant="secondary" size="md" onClick={onClose}>
            {t('adminTags.assign.cancel')}
          </Button>
          <Button
            variant="primary"
            size="md"
            disabled={unassigning}
            onClick={() => onConfirm(tag)}
          >
            {t('adminTags.unassignFlow.action')}
          </Button>
        </>
      }
    >
      <p className={styles.text}>
        {t('adminTags.unassignFlow.question', {
          tag: tag.tagNick ?? tag.tagId,
          name: tag.fullName,
        })}
      </p>
    </Modal>
  );
}